import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-logo',
  templateUrl: './app-logo.component.html',
  styleUrls: ['./app-logo.component.scss'],
})
export class AppLogoComponent implements OnInit, AfterViewInit {
  @Input() size!: number;
  @ViewChild('appLogoImage') appLogoImage!: { nativeElement: HTMLImageElement };

  constructor() {}

  ngAfterViewInit() {
    if (this.size) {
      this.appLogoImage.nativeElement.style.width = '300px !important';
    }
  }

  ngOnInit(): void {}
}
